import React from 'react';
import withNuiIntl from '../utils/withNuiIntl';
import compose from '../utils/compose';
import withStylesLoaded from '../utils/withStylesLoaded';
import IdleTimer from './_IdleTimer';

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppIdleTimer = (props) => <IdleTimer {...props} />;

AppIdleTimer.displayName = 'AppIdleTimer';

AppIdleTimer.propTypes = {
    ...IdleTimer.propTypes,
};

export default compose(
    withStylesLoaded,
    withNuiIntl,
)(AppIdleTimer);
